import { render, staticRenderFns } from "./AdvanceAppointmentDetails.vue?vue&type=template&id=49a53de6&scoped=true&lang=pug&"
import script from "./AdvanceAppointmentDetails.vue?vue&type=script&lang=js&"
export * from "./AdvanceAppointmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./AdvanceAppointmentDetails.vue?vue&type=style&index=0&id=49a53de6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a53de6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAvatar,VDivider,VIcon,VProgressCircular})
